// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"05367fa6","492":"6191edf0","880":"5f3d7e83"}[chunkId] + ".chunk.js";
};